const resources = { backToTop: 'Back to Top' };

export default function getResource(label) {
    return resources[label];
}
